import t from '../actions/actionTypes'

const alertReducer = (state = {lastId: 0, array: []}, action) => {
	switch (action.type) {
		case t.OPEN_ALERT: {
			const uid = state.lastId+1
			return {
				lastId: uid,
				array: [...state.array, {...action.messageObject, uid}],
			}
		}
		case t.CLOSE_ALERT: {
			const index = state.array.findIndex(alert => alert.uid === action.uid)
			if (index !== -1) {
				return {
					lastId: state.lastId,
					array: [...state.array.slice(0, index), ...state.array.slice(index + 1)],
				}
			} else {
				return state
			}
		}
		default:
			return state
	}
}

export default alertReducer
